module.exports = __webpack_public_path__ + "img/high.c0aee1b3.png";